export default __webpack_public_path__ + "static/media/2.e41bd3ea.jpg";